import { useAtomValue } from 'jotai';
import { ListOrderedIcon } from 'lucide-react';

import { ConditionalRender, Skeleton } from '@crossnokaye/ux-common';

import { SequencerEditorConfigType } from '@repo/sdk/models/components';

import { equipmentLoadingAtom } from '@/features/equipment-browser/equipment-details/state/equipment-response.state';
import { sequencerEditorConfigAtom } from '@/features/equipment-browser/equipment-details/state/sequencer-editor.state';
import { SectionTemplate } from '@/features/equipment-browser/equipment-details/templates/section-template';

import { CompressorSequencerEditor } from './compressor-sequencer/compressor-sequencer-editor';
import { CondenserSequencerEditorV1 } from './condenser-sequencer/condenser-sequencer-editor-v1';
import { CondenserSequencerEditorV2 } from './condenser-sequencer/condenser-sequencer-editor-v2';

export const SequencerSection = () => {
  const isLoading = useAtomValue(equipmentLoadingAtom);

  // Tells us what type of sequencer we are dealing with
  const sequencerEditorConfigType = useAtomValue(sequencerEditorConfigAtom)?.type;
  if (!sequencerEditorConfigType) {
    return null;
  }

  return (
    <div>
      <ConditionalRender condition={!isLoading} fallback={<Skeletons />}>
        <SectionTemplate
          title={'Sequencer Configuration'}
          icon={ListOrderedIcon}
          isLoading={isLoading}
        >
          {sequencerEditorConfigType === SequencerEditorConfigType.CondenserSequencerV1 && (
            <CondenserSequencerEditorV1 />
          )}
          {sequencerEditorConfigType === SequencerEditorConfigType.CondenserSequencerV2 && (
            <CondenserSequencerEditorV2 />
          )}
          {sequencerEditorConfigType === SequencerEditorConfigType.CompressorSequencerV1 && (
            <CompressorSequencerEditor />
          )}
        </SectionTemplate>
      </ConditionalRender>
    </div>
  );
};

const Skeletons = () => {
  return (
    <div className="mb-stack-sm">
      <Skeleton className="w-full h-8 mb-thin" />
      <Skeleton className="w-full h-32 mb-thin" />
    </div>
  );
};
